<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="YES_NO_OPTIONS"
      :displayType="displayflex"
      size="sm"
    >
      <template v-slot:label>Has a BDX been submitted into LimeIQ for this Binder section? <span class="text-danger">*</span> </template>
  
      <template v-slot:first>
        <b-form-select-option :value="undefined" disabled
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { YES_NO_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallBdxKeyStatus',
    components: {
      BaseSelect
    },
    props: {
      value: Boolean,
      displayType: String
    },
    emits: ['input'],
    setup(props, { emit }) {   

      const displayflex = "dropdownWidth-sm"
  
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        YES_NO_OPTIONS,  
        modelValue,
        displayflex
      }
    }
  })
  </script>
  